<template>
  <h1>Past Shows</h1>
  <div class="past-shows responsive">
    <div class="show-thumb" @click="selectJurors()">
      <div class="show-image">
        <img src="../assets/jurors.jpg" alt="12 Angry Jurors" />
      </div>
    </div>
    <div class="show-thumb" @click="selectNoTakey()">
      <div class="show-image">
        <img src="../assets/yctiwy-new.png" alt="You Can't Take it With You" />
      </div>
    </div>
    <div class="show-thumb" @click="selectNoises()">
      <div class="show-image">
        <img src="../assets/NoisesOff.jpg" alt="Noises Off" />
      </div>
    </div>
    <div class="show-thumb" @click="selectDracula()">
      <div class="show-image">
        <img src="../assets/dracula.jpg" alt="Dracula" />
      </div>
    </div>
    <div class="show-thumb" @click="selectPlayOn()">
      <div class="show-image">
        <img src="../assets/play-on-md.jpg" alt="Play On" />
      </div>
    </div>
  </div>
  <div class="responsive">
    <h3>{{ showDetails }}</h3>
    <h5 class="sub-heading">{{ photographer }}</h5>
    <div class="gallery">
      <div class="img-column">
        <div
          class="img-container"
          v-for="image in getColumnImages(0)"
          :key="image.id"
        >
          <img :src="getImageUrl(image.alt)" :alt="image.alt" />
        </div>
      </div>
      <div class="img-column">
        <div
          class="img-container"
          v-for="image in getColumnImages(1)"
          :key="image.id"
        >
          <img :src="getImageUrl(image.alt)" :alt="image.alt" />
        </div>
      </div>
      <div class="img-column">
        <div
          class="img-container"
          v-for="image in getColumnImages(2)"
          :key="image.id"
        >
          <img :src="getImageUrl(image.alt)" :alt="image.alt" />
        </div>
      </div>
      <div class="img-column">
        <div
          class="img-container"
          v-for="image in getColumnImages(3)"
          :key="image.id"
        >
          <img :src="getImageUrl(image.alt)" :alt="image.alt" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  setup() {
    const showDetails = ref("");
    const photographer = ref("");
    const images = ref([]);
    const initImages = (name, path, start, stop) => {
      let col = 0;
      for (let i = start; i <= stop; i++) {
        images.value.push({
          id: i,
          col: col++,
          src: `${path}/${name}-${i}.jpg`,
          alt: `${name}-${i}.jpg`,
        });
        if (col === 4) col = 0;
      }
    };

    const selectJurors = () => {
      images.value.length = 0;
      showDetails.value = "12 Angry Jurors - Fall 2021";
      photographer.value = "Photos by Mark V Photography";
      initImages("12angry", "../assets", 1, 14);
    };
    const selectNoTakey = () => {
      images.value.length = 0;
      showDetails.value = "You Can't Take It With You - Fall 2019";
      photographer.value = "Photos by Mark V Photography";
      initImages("yctiwy", "../assets", 1, 14);
    };

    const selectNoises = () => {
      images.value.length = 0;
      showDetails.value = "Noises Off! - Fall 2018";
      photographer.value = "Photos by Mark V Photography";
      initImages("noises", "../assets", 1, 30);
    };

    const selectDracula = () => {
      images.value.length = 0;
      showDetails.value = "Dracula - Fall 2017";
      photographer.value = "Photos by Mark V Photography";
      initImages("dracula", "../assets", 1, 29);
    };

    const selectPlayOn = () => {
      images.value.length = 0;
      showDetails.value = "Play On - Fall 2016";
      photographer.value = "Photos by Jennifer Lowe Photography";
      initImages("playon", "../assets", 1, 8);
    };

    const getImageUrl = (image) => {
      let imgs = require.context("../assets/", false, /\.jpg$/);
      return imgs("./" + image);
    };

    const getColumnImages = (colnum) => {
      return images.value.filter((image) => image.col === colnum);
    };

    return {
      showDetails,
      photographer,
      images,
      selectJurors,
      selectNoTakey,
      selectNoises,
      selectDracula,
      selectPlayOn,
      getImageUrl,
      getColumnImages,
    };
  },
};
</script>

<style>
.responsive {
  margin: 0 15vw;
}

.past-shows {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 1rem;
}

.show-thumb {
  width: 100%;
  cursor: pointer;
}

.show-image img {
  width: 100%;
}

.sub-heading {
  margin: -15px 0 15px 0;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.img-column {
  flex: 25%;
  max-width: 25%;
}

.img-column .img-container {
  margin: 4px 4px 0 4px;
  vertical-align: middle;
}

.img-column .img-container img {
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .img-column {
    flex: 50%;
    max-width: 50%;
  }
}

@media screen and (max-width: 800px) {
  .img-column {
    flex: 100%;
    max-width: 100%;
  }

  .responsive {
    margin: 0 1rem;
  }
}
</style>
